import React from 'react';
import Link from 'gatsby-link';

const Header = () => (
    <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-light p-0">
            <div className="container-fluid px-lg-5">
                <a className="navbar-brand" href='/'>
                    <img src="../images/layout/logo/kentweb-logo-211-44.png" className="img-fluid" />
                </a>
                <button className="navbar-toggler" type='button' data-toggle='collapse' data-target='#navbarNav' aria-controls='navbarNav' aria-expanded='false' aria-label='Toggle navigation'>
                    <span className="navbar-toggler-icon" />
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <Link
                                className="nav-link px-3"
                                exact to="/"
                                activeClassName="active"
                            >
                                Home
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link px-3"
                                to="/services/"
                                activeClassName="active"
                            >
                                Services
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link px-3"
                                to="/about/"
                                activeClassName="active"
                            >
                                About
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link px-3"
                                to="/careers/"
                                activeClassName="active"
                            >
                                Careers
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link px-3"
                                to="/contact/"
                                activeClassName="active"
                            >
                                Contact
                            </Link>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>
    </header >
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js